<template>
  <div class="module">
    <h3 class="h3">{{objData[name].title}}</h3>
    <p v-if="objData[name].p" v-html="objData[name].p"  :class="objData[name].pclass"  class="ft30"></p>
    <div  v-if="objData[name].ullist&&objData[name].ullist!=null">
      <ul :class="objData[name].class">
        <li v-for="(item,index) in objData[name].ullist" :key="index">
            <div class="img"><img v-if="item.src" :src="item.src" alt=""></div>
            <div>
              <h4 v-if="item.title">{{item.title}}</h4>
              <p v-html="item.p"></p>
            </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style>
</style>
<script>
import Text from '../utils/text'
export default {
  props:{
    obj:String,
    name:String
  },
  data(){
    return {
      objData:{}
    }
  },
  created(){
    this.objData = Text.websiteText[this.obj]
  }
}
</script>
<style lang="scss">
  .module{
    margin-top:27px;
    h3{
      font-size:36px;
      line-height:76px;
      font-weight: bold;
      text-align: center;
    }
    .ft30{
      font-size:30px;
    }
  }
  .card{
    margin:50px 22px 0;
    li{
      @include flex;
       flex-direction: row-reverse;
       margin-bottom: 50px;
      .img{
        @include center;
        img{
          display:block;
          width:91%;
        }
      }
      div{
        width:350px;
        text-align: center;
        h4{
          margin:0 auto 24px;
          color:#f0f9fe;
          font-size:28px;
          line-height:40px;
          padding:0 40px;
          border-radius:15px;
          display: inline-block;
          background:#6089f5;
        }
        p{
          font-size:24px;
          color:#666;
          line-height:38px;
        }
      }
    }
    li:nth-child(2n){
      flex-direction: row;
    }
  }
  .poster{
    li{
      flex-direction: row;
      div{
        p{
          font-size:28px;
        }
      }
      
    }
  }
  
</style>
